import PhoneIphoneOutlinedIcon from '@material-ui/icons/PhoneIphoneOutlined';
import SmsOutlinedIcon from '@material-ui/icons/SmsOutlined';

export const RETURN_URL_STORAGE_KEY = 'returnUrl';
export const LOGOUT_REASON = {
  AUTH_FAIL: 'AUTH_FAIL',
  SIGN_IN_CLEANUP: 'SIGN_IN_CLEANUP',
  USER_ACTION: 'USER_ACTION',
  TMD_FAIL: 'TMD_FAIL',
  USER_BLOCKED: 'USER_BLOCKED',
};

export const MFA_TYPE = {
  AUTH_APP: 'auth_app', //authenticator application
  SMS: 'sms',
};

export const MFA_TYPE_LABEL = {
  [MFA_TYPE.AUTH_APP]: 'mfa.setup.app.label',
  [MFA_TYPE.SMS]: 'mfa.setup.sms.label',
};

export const MFA_TYPE_OPTIONS = [
  {
    value: MFA_TYPE.AUTH_APP,
    label: MFA_TYPE_LABEL[MFA_TYPE.AUTH_APP],
    icon: PhoneIphoneOutlinedIcon,
    description: 'mfa.setup.app.description',
  },
  {
    value: MFA_TYPE.SMS,
    label: MFA_TYPE_LABEL[MFA_TYPE.SMS],
    icon: SmsOutlinedIcon,
    description: 'mfa.setup.sms.description',
  },
];

export const SMS_EXPIRATION_TIME_MS = 1000 * 60 * 2; // 2 minutes, back end logic

export const VERIFICATION_PHONE_NUMBER_MODAL = 'VERIFICATION_PHONE_NUMBER_MODAL';
export const VERIFICATION_PHONE_NUMBER_FORM = 'VERIFICATION_PHONE_NUMBER_FORM';

export const SMS_VERIFICATION_TYPE = {
  MFA: 'mfa',
  PHONE_NUMBER: 'phone_number',
};
